const state = {
    build: {},
    cart: [],
    originalPrice: 0,
    range: 0,
    totalPrice: 0
};

const mutations = {
    PROMOS_REMOVE_CART_PART(state, payload) {
        state.cart = state.cart.filter(variant => variant.products_id != payload.products_id);
    },
    PROMOS_RESET_CART(state) {
        state.cart = [];
    },
    PROMOS_SET_BUILD(state, payload) {
        state.build = payload;
    },
    PROMOS_SET_GAMES(state, payload) {
        state.build.games = payload;
    },
    PROMOS_SET_ORIGINAL_PRICE(state, payload) {
        state.originalPrice = payload;
    },
    PROMOS_SET_RANGE(state, payload) {
        state.range = payload;
    },
    PROMOS_SET_TOTAL_PRICE(state, payload) {
        state.totalPrice = payload;
    },
    PROMOS_UPDATE_CART_PART(state, payload) {
        const itemIndex = state.cart.findIndex(variant => variant.products_id == payload.products_id);

        if (itemIndex >= 0) {
            state.cart.splice(itemIndex, 1, payload);
        } else {
            state.cart.push(payload);
        }
    },
    PROMOS_UPDATE_PART_QUANTITY(state, payload) {
        const itemIndex = state.cart.findIndex(variant => variant.products_id == payload.item.products_id);

        state.cart[itemIndex].quantity = payload.quantity;
    }
};

const actions = {
    promosRemoveCartPart({ commit }, data) {
        commit("PROMOS_REMOVE_CART_PART", data);
    },
    promosResetCart({ commit }, data) {
        commit("PROMOS_RESET_CART", data);
    },
    promosSetBuild({ commit }, data) {
        commit("PROMOS_SET_BUILD", data);
    },
    promosSetGames({ commit }, data) {
        commit("PROMOS_SET_GAMES", data);
    },
    promosSetOriginalPrice({ commit }, data) {
        commit("PROMOS_SET_ORIGINAL_PRICE", data);
    },
    promosSetRange({ commit }, data) {
        commit("PROMOS_SET_RANGE", data);
    },
    promosSetTotalPrice({ commit }, data) {
        commit("PROMOS_SET_TOTAL_PRICE", data);
    },
    promosUpdateCartPart({ commit }, data) {
        commit("PROMOS_UPDATE_CART_PART", data);
    },
    promosUpdatePartQuantity({ commit }, data) {
        commit("PROMOS_UPDATE_PART_QUANTITY", data);
    }
};

export default {
    state,
    mutations,
    actions
};
